import { render, staticRenderFns } from "./NoticeService.vue?vue&type=template&id=6899910e&"
import script from "./NoticeService.vue?vue&type=script&lang=ts&"
export * from "./NoticeService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports